import { render, staticRenderFns } from "./DailyCauselist.vue?vue&type=template&id=e4fa48b6"
import script from "./DailyCauselist.vue?vue&type=script&lang=js"
export * from "./DailyCauselist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports